<template>
  <div class="dashboard">
    <AuditMetadataDialog
      :dialog-data="getAuditMetadataDialogData"
      :dialog.sync="dialog"
      v-if="dialog"
    />
    <audit-import-dialog :dialogImport.sync="dialogImport" v-if="dialogImport"></audit-import-dialog>

    <v-layout row wrap>
      <v-flex xs12 pa-2>
        <v-toolbar flat class="secondary lighten-2 elevation-1" dark>
          <v-toolbar-title>
            <span>{{ $t('audit_matrix_auditplan') }}&nbsp;</span>
          </v-toolbar-title>
          <v-menu :nudge-width="100">
            <v-toolbar-title slot="activator">
              <span>{{currentYear.name}}</span>
              <v-icon>arrow_drop_down</v-icon>
            </v-toolbar-title>

            <v-list>
              <v-list-tile v-for="year in years" :key="year.id" @click="currentYear = year">
                <v-list-tile-title v-text="year.name"></v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <v-badge color="primary" overlap>
            <template v-slot:badge>
              <span v-if="filterCount">{{filterCount}}</span>
            </template>
            <v-btn tile @click="drawerRightVisible = !drawerRightVisible">
              <v-icon color="primary">filter_list</v-icon>
            </v-btn>
          </v-badge>
          <more-menu v-if="adminview" :items="more_menu" @itemimport="dialogImport = !dialogImport"></more-menu>
        </v-toolbar>
        <v-data-table
          :headers="config.matrix.headers"
          :items="currentAudits"
          :search="search"
          :pagination.sync="listConfigPaginationDataTable"
          hide-actions
          class="elevation-1"
          id="paginationstart"
        >
          <template slot="items" slot-scope="props">
            <td v-if="config.matrix.auditname" @click="$router.push('/audit/' + props.item.id)">
              <v-icon small v-if="props.item.protected == true">lock</v-icon>
              <v-icon
                small
                v-if="!props.item.hasPendingWrites && !props.item.fromCache"
                class="green--text"
                title="Das Dokument ist syncronisiert"
              >done_all</v-icon>
              <v-icon
                small
                v-else-if="props.item.hasPendingWrites"
                class="orange--text"
                title="Das Dokument ist noch nicht syncronisiert"
              >done</v-icon>
              <v-icon small v-else title="Das Document kommt aus dem Cache">cached</v-icon>
              {{ props.item.name }}
            </td>
            <td
              v-if="config.matrix.standard"
              @click="$router.push('/audit/' + props.item.id)"
              class="text-xs-right"
            >{{props.item.standard}}</td>
            <td
              v-if="config.matrix.type"
              @click="$router.push('/audit/' + props.item.id)"
              class="text-xs-right"
            >{{ props.item.type }}</td>
            <td
              v-if="config.matrix.audited_by"
              @click="$router.push('/audit/' + props.item.id)"
              class="text-xs-right"
            >{{ props.item.audited_by }}</td>
            <td
              v-if="config.matrix.scope"
              @click="$router.push('/audit/' + props.item.id)"
              class="text-xs-right"
            >
              <snippet-scope :scope="props.item.scope" format="matrix" :mapping="mapping"></snippet-scope>
            </td>
            <td
              v-if="config.matrix.auditor"
              @click="$router.push('/audit/' + props.item.id)"
              class="text-xs-right"
            >
              <span style="border-bottom: 1px solid blue;">{{props.item.leadauditor}}</span>
              <template v-if="props.item.coauditors">
                <br />
                {{props.item.coauditors}}
              </template>
              <br />
            </td>
            <td
              v-if="config.matrix.planning_date"
              @click="$router.push('/audit/' + props.item.id)"
              class="text-xs-right"
            >
              <SnippetDate :items="props.item.planning_date_display"></SnippetDate>
            </td>
            <td
              v-if="config.matrix.auditing_date"
              @click="$router.push('/audit/' + props.item.id)"
              class="text-xs-right"
            >
              <SnippetDate :items="props.item.auditing_date_display"></SnippetDate>
            </td>
            <td
              v-if="config.matrix.status"
              @click="$router.push('/audit/' + props.item.id)"
              class="text-xs-right"
            >{{props.item.status}}</td>
            <td v-if="config.matrix.edit" class="justify-center layout px-0"></td>
            <td class="justify-center layout px-0">
              <v-btn icon class="mx-0" @click="editItem(props.item.id)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">{{ $t('audit_matrix_nodata')}}</template>
          <template slot="page-text" slot-scope="props">{{ props }}</template>
        </v-data-table>

        <PaginationControl
          v-if="listConfigPaginationRequired"
          :page-sizes="listConfigPageSizes"
          :length="listConfigPageCount"
          @change="listConfigOnPaginationChange"
        />

        <v-btn
          fab
          :style="fabStyle"
          bottom
          clipped
          right
          color="pink"
          dark
          fixed
          @click="createItem()"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>

      <drawer-right
        :drawerRightVisible="drawerRightVisible"
        @toggleDrawer="drawerRightVisible = !drawerRightVisible"
      >
        <ItemsJsFacets
          slot="content"
          :per-page="listConfigPageSize"
          :page="listConfigPage"
          :configuration="listConfigItemsJs"
          :rows="audits"
          @itemsjs-result-list-changed="onIitemsjsResultListChanged"
        ></ItemsJsFacets>
      </drawer-right>
    </v-layout>
  </div>
</template>

<i18n>
  {
    "de": {
      "audit_matrix_auditplan" : "Auditplan",
      "audit_matrix_title" : "Name",
      "audit_matrix_standard" : "Standard",
      "audit_matrix_type" : "Typ",
      "audit_matrix_art" : "Art",
      "audit_matrix_scope" : "Bereich",
      "audit_matrix_created" : "Angelegt",
      "audit_matrix_actions" : "Aktionen",
      "audit_matrix_import" : "Audits importieren",
      "audit_matrix_nodata" : "Keine Ergebnisse",
      "audit_matrix_facets_standard" : "Standard",
      "audit_matrix_facets_type" : "Audittyp",
      "audit_matrix_facets_art" : "Auditart",
      "audit_matrix_facets_leadauditor" : "Leadauditor",
      "audit_matrix_facets_year" : "Planjahr"
    },
    "en": {
      "audit_matrix_auditplan" : "Auditplan",
      "audit_matrix_title" : "Name",
      "audit_matrix_standard" : "Standard",
      "audit_matrix_type" : "Type",
      "audit_matrix_art" : "Art",
      "audit_matrix_scope" : "Scope",
      "audit_matrix_created" : "Created by",
      "audit_matrix_actions" : "Actions",
      "audit_matrix_import" : "Import Audits",
      "audit_matrix_nodata" : "No data",
      "audit_matrix_facets_standard" : "Standard",
      "audit_matrix_facets_type" : "Audittype",
      "audit_matrix_facets_art" : "Auditart",
      "audit_matrix_facets_leadauditor" : "Leadauditor",
      "audit_matrix_facets_year" : "Planned Year"
    }
  }
</i18n>

<script>
// Dialogs
import AuditMetadataDialog from "@/components/dialogs/AuditMetadataDialog.vue";

// Snippets / Controls
import SnippetDate from "@/components/snippets/SnippetDate.vue";
import SnippetScope from "@/components/snippets/SnippetScope.vue";
import ItemsJsFacets from "@/components/controls/ItemsJsFacets.vue";
import MoreMenu from "@/components/snippets/MoreMenu.vue";
import PaginationControl from "@/components/controls/PaginationControl";

// Layouts
import DrawerRight from "@/components/layouts/BaseLayouts/DrawerRight.vue";

// Mixins
import FabMixin from "@/components/mixins/FabMixin";
import ListConfigurationMixin from "@/components/mixins/ListConfigurationMixin";

import uuid from "uuid";

import { mapGetters, mapActions } from "vuex";
import { api } from "@/store/modules/audits";
import { api as confApi } from "@/store/modules/configuration";

export default {
  name: "auditmatrix",
  components: {
    AuditMetadataDialog,
    SnippetDate,
    SnippetScope,
    ItemsJsFacets,
    DrawerRight,
    MoreMenu,
    PaginationControl
  },

  mixins: [FabMixin, ListConfigurationMixin],
  data() {
    return {
      filterCount: 0,
      mapping: {
        site: "Site"
      },
      more_menu: [
        // TODO: In Konfiguration
        { title: this.$i18n.t("audit_matrix_import"), event: "itemimport" }
      ],
      currentYear: { id: "2019", name: "2019" },
      search: "",
      drawerRightVisible: false,
      dialogImport: false,
      currentAudits: [], // Filterd Audit from ItemsJS
      loadedAudits: [], // Response from Firebaselisten

      isUpdate: false,
      date: null,
      activeAudit: false,
      unlistener: null
    };
  },
  created() {
    if (this.config.matrix.currentYear) {
      this.currentYear = {
        id: this.config.matrix.currentYear,
        name: this.config.matrix.currentYear
      };
    }
    this.loadAudits({ year: this.activeYear }).then(unlistener => {
      this.unlistener = unlistener;
    });
  },
  beforeDestroy() {
    this.clearAudits(this.unlistener);
  },
  watch: {
    activeYear() {
      this.loadAudits({ year: this.activeYear });
    }
  },
  computed: {
    ...mapGetters(api.namespace, [
      api.getters.createNewAudit,
      api.getters.getFlatAuditMatrix,
      api.getters.getAuditById
    ]),
    adminview() {
      if (this.$route.query.admin) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters(confApi.namespace, [confApi.getters.audit]), // TODO: Name des getters eindeutiger
    audits() {
      return this.getFlatAuditMatrix;
    },
    years() {
      // Put into configuration OR BETTER: dynamically create years!
      // TODO: Filter on undefined dates
      let years = [
        { id: "2018", name: "2018" },
        { id: "2019", name: "2019" },
        { id: "2020", name: "2020" },
        { id: "", name: "Alle" }
      ];

      return years;
    },
    activeYear() {
      const year = this.currentYear.id;

      if (year === "") {
        return null;
      } else {
        return parseInt(year, 10);
      }
    },
    config() {
      return this.audit;
    },
    dialog: {
      set(newVal) {
        if (newVal === false) {
          this.activeAudit = false;
        }
      },
      get() {
        return this.activeAudit !== false;
      }
    },
    getAuditMetadataDialogData() {
      return {
        id: this.activeAudit,
        metadata: this.activeAudit
          ? this.getAuditById(this.activeAudit)
          : this.createNewAudit()
      };
    },
    // Overwrites from ListConfigurationMixin
    listConfigConfigKey: () => "auditmatrix",
    listConfigTotalItemCount() {
      return this.currentAudits.length;
    }
  },

  methods: {
    ...mapActions(api.namespace, [
      api.actions.deleteAudit,
      api.actions.setAuditId,
      api.actions.setDialogItem,
      api.actions.setDialogAction,
      api.actions.loadAudits,
      api.actions.clearAudits
    ]),
    onIitemsjsResultListChanged(d, filter, query) {
      this.filterCount =
        (query === "" ? 0 : 1) +
        Object.values(filter).reduce((prev, item) => prev + item.length, 0);
      this.currentAudits = d;
    },
    editItem(audit_id) {
      this.activeAudit = audit_id;
    },
    createItem() {
      this.activeAudit = null;
    },

    deleteItem(item) {
      const index = this.audits.indexOf(item);
      const payload = {
        audit_id: this.audits[index].id,
        activity: {
          id: uuid.v4(),
          actor: this.$user.id(),
          verb:
            this.$user.displayName() +
            " hat das Audit " +
            this.audits[index].name +
            " gelöscht.",
          object: this.audits[index].id,
          //object_url: "/audit/" + this.audits[index].id,
          timestamp: new Date().toISOString().slice(0, 10)
        }
      };

      confirm("Are you sure you want to delete this item?") &&
        this.deleteAudit(payload);
    }
  }
};
</script>
